/**
 * Created by sung.hwang on 9/7/17.
 */
/**
 * CLICKED_SEND_TEXT
 * TEXT_SENT
 * TEXT_SEND_FAILED
 */

export const Actions = {
    CLICKED_SEND_TEXT: '@@textMeTheApp/CLICKED_SEND_TEXT',
    CHANGE_PHONE_NUMBER: '@@textMeTheApp/CHANGE_PHONE_NUMBER',
    SEND_APP_TEXT_ERROR: '@@textMeTheApp/SEND_APP_TEXT_ERROR',
    SEND_APP_TEXT_SUCCESS: '@@textMeTheApp/SEND_APP_TEXT_SUCCESS',
};

export const clickedSendText = () => ({
    type: Actions.CLICKED_SEND_TEXT,
});

export const changedPhoneNumber = number => ({
    type: Actions.CHANGE_PHONE_NUMBER,
    phoneNumber: number,
});

export const sendAppTextSuccess = () => ({
    type: Actions.SEND_APP_TEXT_SUCCESS,
});

export const sendAppTextError = () => ({
    type: Actions.SEND_APP_TEXT_ERROR,
});

export function textAppLink(number) {
    return dispatch => {
        dispatch(clickedSendText());
        if (typeof window !== 'undefined' && window.branch) {
            const linkData = {
                tags: ['Homepage'],
                channel: 'Website',
                feature: 'TextMeTheApp',
                data: {},
            };
            const callback = err => {
                if (err) {
                    dispatch(sendAppTextError());
                } else {
                    dispatch(sendAppTextSuccess());
                }
            };
            window.branch.sendSMS(number, linkData, {}, callback);
        }
    };
}

export function onChangePhoneNumber(number) {
    return dispatch => {
        dispatch(changedPhoneNumber(number));
    };
}
